import cn from 'classnames'
import React from 'react'

import styles from './MenuListSubheadig.module.scss'

export type MenuListSubheadingProps = React.LiHTMLAttributes<HTMLLIElement> & {
  after?: React.ReactNode
  children?: React.ReactNode
}

function MenuListSubheading({ after, children, className, ...props }: MenuListSubheadingProps) {
  return (
    <li className={cn(styles.root, className)} {...props}>
      <div className={styles.container}>
        <div className={styles.title}>{children}</div>
        <div className={styles.after}>{after}</div>
      </div>
    </li>
  )
}

export default MenuListSubheading
